import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navigation from "../navigation/mainNavBar";
import { useCookies } from "react-cookie";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import "./Panel.scss";

import Footer from "../footer/Footer";
import List from "./List";

function Application() {
  let navigate = useNavigate();
  const [statisticsData, setStatisticsData] = useState({});

  const [cookies, setCookie, removeCookie] = useCookies(["accept-cookies"]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      document.title = document.hidden
        ? "Prosimy się nie opierdalać!!🤠"
        : "WildLandsRP.pl - Polski Serwer RP RDR2";
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  useEffect(() => {
    if (!cookies["accept-cookies"]) {
      let path = `/`;
      navigate(path);
      return () => {};
    }
    fetch("./requestStatistics.php", {
      // credentials: "include",
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "error") {
          let path = `/`;
          navigate(path);
          return () => {};
        }
        setStatisticsData(data);
      });
  }, []);

  useEffect(() => {
    const sectionOffset =
      document.querySelector("section:first-of-type").offsetTop * 0.8;
    window.scrollTo({
      top: sectionOffset,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="Application">
      <Navigation />
      <div className="content">
        <div className="title">WildLandsRP</div>
        <div className="sub-title">
          Przyjaciele, wrogowie i fortuna czekają na Ciebie!
        </div>
        <div className="main-butons-line"></div>
      </div>
      <div className="section-title">Statystyki</div>
      <section className="grid2">
        <div className="grid-item"></div>
        <div className="grid-item">
          Poniżej przedstawimy kilka statystyk, na temat sprawdzania podań
          whitelist u nas na serwerze.
        </div>
        <div className="grid-item"></div>
      </section>
      <section className="grid">
        <div className="grid-item">
          <h3>Osoba która sprawdziła najwięcej podań:</h3>
          <img src={statisticsData.topavatar} alt="Zdjencie" />
          <h4>
            {statisticsData.topname} <br /> {statisticsData.topcount}
          </h4>
        </div>
        <div className="grid-item">
          <h3>Osoba która odrzuciła najwięcej podań:</h3>
          <img src={statisticsData.toprejectedavatar} alt="Zdjencie" />
          <h4>
            {statisticsData.toprejectedname} <br />
            {statisticsData.toprejectedcount}
          </h4>
        </div>
        <div className="grid-item">
          <h3>Ilość podań:</h3>
          <h4>{statisticsData.all}</h4>
        </div>
      </section>
      <section className="grid">
        <div className="grid-item">
          <h3>Ilość zakceptowanych podań:</h3>
          <h4>{statisticsData.accepted}</h4>
        </div>
        <div className="grid-item">
          <h3>Ilość odrzuconych podań:</h3>
          <h4>{statisticsData.rejected}</h4>
        </div>
        <div className="grid-item">
          <h3>Osób oczekujących na weryfikacje:</h3>
          <h4>{statisticsData.verification}</h4>
        </div>
      </section>
      <div className="section-title">Ilość podań przez ostatni tydzień</div>
      <section className="chart">
        <ResponsiveContainer>
          <AreaChart
            responsive={true}
            data={statisticsData.chartdata}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#e2b55a" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#e2b55a" stopOpacity={0.1} />
              </linearGradient>
            </defs>
            <XAxis dataKey="date" />
            <YAxis
              allowDecimals={false}
              type="number"
              allowDataOverflow={false}
              domain={[0, 33]}

              // Math.max(
              //   ...((statisticsData.chartdata
              //     ? statisticsData.chartdata
              //     : []
              //   ).map((obj) => obj.count) + 3)
              // )
            />
            <Tooltip />
            <Area
              type="linear"
              dataKey="count"
              stroke="#e2b55a"
              fillOpacity={0.2}
              fill="url(#colorUv)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </section>
      <List />
      <Footer />
    </div>
  );
}

export default Application;
